import {Dispatch, EntityFactory, Reducer} from '@modifi/redux'
import {
  getAuthenticatedThemisClient,
  CompanyRegistrationDetailsView,
} from '@modifi/onboarding-api-clients'
import {COMPANY_CIN_CODE} from '@modifi/plugin-onboarding'
import {createSelector} from 'reselect'

import {fieldNameToProperty} from '../company/utils'

type State = Record<string, any>
const client = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = EntityFactory({
  actionNamePrefix: 'data/companyRegistration',
  reducerPath: ['data', 'companyRegistration'],
  fetchRequest: (): Promise<CompanyRegistrationDetailsView> =>
    client.CompanyRegistrationDetails.byCompanyId().then(res => res.data()),
})

export default reducer as Reducer

export const selectCompanyRegistration = (state: State): CompanyRegistrationDetailsView | null =>
  selectors.selectEntity(state) as CompanyRegistrationDetailsView | null
export const selectCompanyRegistrationIsLoading = selectors.selectIsLoading

export const selectCompanyCinCode = createSelector(
  selectCompanyRegistration,
  // @ts-expect-error null check already added
  companyRegistration => companyRegistration?.[fieldNameToProperty(COMPANY_CIN_CODE) || ''] || null
)

export const aFetchCompanyRegistrationByExternalId = (): any => actions?.fetch()

export const aUpdateRegistrationDetails = (data: CompanyRegistrationDetailsView): any =>
  actions?.update(data)

export const aEnsureCompanyRegistrationByExternalId =
  (externalCompanyId: string) =>
  (dispatch: Dispatch, getState: () => Record<string, any>): void => {
    if (
      selectCompanyRegistrationIsLoading(getState()) ||
      selectCompanyRegistration(getState())?.externalId === externalCompanyId
    ) {
      return
    }
    dispatch(aFetchCompanyRegistrationByExternalId())
  }
